export const agendamientoRoutes = [
  {
    path: '/agendamiento/agendar',
    name: 'AgendaAgendar',
    desplegable: false,
    icon: 'mdiCalendarCursorOutline',
    typeIcon: 'mdi',
    menu: true,
    meta: {
      forceRemount: true,
      permiso: ['agendarConsultas'],
      perfiles: ['ADMISIONES'],
      title: 'Agendar citas',
      subTitle: 'Gestión de agendamiento de citas',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "agendamiento" */ '@/modules/Agendamiento/views/Agendamiento/AgendamientoForm.vue'
      )
  },
  {
    path: '/agendamiento/agendar-orden/:sessionId?',
    name: 'AgendaAgendarOrden',
    desplegable: false,
    icon: 'mdiCalendarCursorOutline',
    typeIcon: 'mdi',
    menu: false,
    meta: {
      forceRemount: true,
      permiso: ['agendarConsultas'],
      perfiles: ['ADMISIONES'],
      title: 'Agendar Ordenes médicas',
      subTitle: 'Gestión de agendamiento de citas',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "agendamiento" */ '@/modules/Agendamiento/views/Agendamiento/AgendamientoForm.vue'
      )
  },
  {
    path: '/agendamiento/agendar/:coppId',
    name: 'AgendaAgendarPaciente',
    desplegable: false,
    icon: 'mdiCalendarCursorOutline',
    typeIcon: 'mdi',
    menu: false,
    meta: {
      forceRemount: true,
      permiso: [],
      perfiles: ['ADMISIONES'],
      title: 'Agendar cita',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "agendamiento" */ '@/modules/Agendamiento/views/Agendamiento/AgendamientoForm.vue'
      )
  },
  {
    path: '/agendamiento/reagendar/:ciagId',
    name: 'AgendaReagendar',
    desplegable: false,
    icon: 'mdiCalendarCursorOutline',
    typeIcon: 'mdi',
    menu: false,
    meta: {
      forceRemount: true,
      permiso: ['agendarConsultas'],
      perfiles: ['ADMISIONES'],
      title: 'Agendar cita',
      requiresSession: true
    },
    children: [],
    component: () =>
      import(
        /* webpackChunkName: "agendamiento" */ '@/modules/Agendamiento/views/Agendamiento/AgendamientoForm.vue'
      )
  }
]
